import React from 'react';
import Footer from '@src/pages/workflow/components/BuilderWrapper/Footer';
import {
  BuilderWrapperButtonProps,
  BuilderWrapperProps,
} from '@src/pages/workflow/components/BuilderWrapper/type';
import {
  StyledContentWrapper,
  StyledFooterWrapper,
  StyledFormError,
  StyledTitle,
  StyledWrapper,
} from '@src/pages/workflow/components/BuilderWrapper/styled';

const BuilderWrapper: React.FC<BuilderWrapperProps> = ({
  title,
  extra,
  children,
  style,
  footer,
  error,
}) => {
  const isFooterObject = typeof footer === 'object';
  const isFooterRender = typeof footer === 'function';

  let footerDom = footer;
  if (isFooterObject) {
    footerDom = <Footer {...(footer as BuilderWrapperButtonProps)} />;
  }
  if (isFooterRender) {
    footerDom = footer(Footer);
  }
  return (
    <StyledWrapper style={style}>
      {/*<StyledTitle>*/}
      {/*  {title} <div>{extra ? extra : null}</div>*/}
      {/*</StyledTitle>*/}
      <StyledContentWrapper>{children}</StyledContentWrapper>
      {error && <StyledFormError>{error}</StyledFormError>}
      <StyledFooterWrapper>{footerDom}</StyledFooterWrapper>
    </StyledWrapper>
  );
};

export default BuilderWrapper;
